import React from "react";
import { Box, Grid, Typography, Paper, Container, Button } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import girl from "./Images/girl..png";
import Summercollection from "./Summercollection";
import OfferCard from "./OfferCard";
import Wintercollection from "./Wintercollection";
import Trending from "./Trending";
import { useNavigate } from "react-router-dom";
import Comments from "./Comments";
import delivary from "./Images/delivary.jpg";
import connection from "./Images/connection.avif";
import brand from "./Images/quality.avif";
import tshirt from "./Images/tshirt.avif";
const Homepage = () => {
  const navigate = useNavigate();
  return (
    <React.Fragment>
      <Container>
        <Box sx={{ mt: { lg: 15, xs: 0, md: 15 } }}>
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} xs={12}>
              <Typography sx={{ fontSize: "2.5rem", mt: 15 }}>
                {" "}
                <span style={{ color: "#022a6b", fontWeight: "bold" }}>
                  Style
                </span>{" "}
                Speaks Louder
                <br /> than{" "}
                <span style={{ color: "#022a6b", fontWeight: "bold" }}>
                  Words
                </span>
              </Typography>
              <Typography sx={{ marginTop: 3 }}>
                Bella Store, your premier destination for chic fashion online.
                Explore our curated selection of stylish apparel, from casual
                essentials to sophisticated evening attire. With a focus on
                quality and trendsetting designs, we provide the perfect outfits
                for every occasion. Elevate your wardrobe with Bella Store's
                distinctive collection today.
              </Typography>
              <Button
                onClick={() => navigate("/collection")}
                variant="contained"
                sx={{
                  boxShadow: 24,
                  borderRadius: 5,
                  bgcolor: "#022a6b",
                  fontSize: "1.2rem",
                  color: "white",
                  padding: "8px 20px 8px 20px",
                  cursor: "pointer",
                  marginTop: 5,

                  "&:hover": {
                    transform: "scale(1.05)",
                    transition: "0.2s",
                    bgcolor: "white",
                    color: "#022a6b",
                  },
                }}
              >
                Explore
                <ArrowForwardIcon />
              </Button>
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <Paper
                elevation={24}
                sx={{
                  borderRadius: "250px 250px 50px 50px",
                  ml: { lg: 25, md: 15, xs: 4 },
                  background: "radial-gradient(circle,white,#1a193a,#1a193a)",
                  width: { lg: 350, xs: 300, md: 300 },

                  height: { lg: 555, xs: 475 },
                }}
              >
                <Box
                  component="img"
                  src={girl}
                  sx={{
                    mt: "auto",
                    width: { lg: "100%", xs: "100%", md: "100%" },
                    height: "auto",
                    objectFit: "cover",
                    padding: 0,
                    margin: 0,
                  }}
                />
              </Paper>
            </Grid>
          </Grid>
        </Box>
        <Grid container spacing={4} mt={5}>
          <Grid item lg={3} md={4} xs={12} sm={6}>
            {" "}
            <Box
              sx={{
                display: "flex",
                boxShadow: 24,
                borderRadius: 10,
                padding: 0.5,
                cursor: "pointer",
                ":hover": {
                  transform: "scale(1.05)",
                  transition: "0.3sec",
                },
              }}
            >
              <Box
                component="img"
                src={delivary}
                sx={{ borderRadius: 400, width: 70 }}
              />
              <Typography
                sx={{ mt: 2.2, ml: 1.5, fontSize: "1.1rem", color: "#022a6b",cursor: "pointer",
                ":hover": {
                  transform: "scale(1.05)",
                  transition: "0.3sec",
                }, }}
              >
                Timely Delivery
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={3} md={4} xs={12} sm={6}>
            {" "}
            <Box
              sx={{
                display: "flex",
                boxShadow: 24,
                borderRadius: 10,
                padding: 0.5,cursor: "pointer",
                ":hover": {
                  transform: "scale(1.05)",
                  transition: "0.3sec",
                },
              }}
            >
              <Box
                component="img"
                src={brand}
                sx={{ borderRadius: 400, width: 70 }}
              />
              <Typography
                sx={{ mt: 2.4, ml: 1.5, fontSize: "1.1rem", color: "#022a6b" }}
              >
                Quality Control
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={3} md={4} xs={12} sm={6}>
            {" "}
            <Box
              sx={{
                display: "flex",
                boxShadow: 24,
                borderRadius: 10,
                padding: 0.5,cursor: "pointer",
                ":hover": {
                  transform: "scale(1.05)",
                  transition: "0.3sec",
                },
              }}
            >
              <Box
                component="img"
                src={tshirt}
                sx={{ borderRadius: 400, width: 70 }}
              />
              <Typography
                sx={{ mt: 2.4, ml: 1.5, fontSize: "1.1rem", color: "#022a6b" }}
              >
                Brand Identity
              </Typography>
            </Box>
          </Grid>
          <Grid item lg={3} md={4} xs={12} sm={6}>
            {" "}
            <Box
              sx={{
                display: "flex",
                boxShadow: 24,
                borderRadius: 10,
                padding: 0.5,cursor: "pointer",
                ":hover": {
                  transform: "scale(1.05)",
                  transition: "0.3sec",
                },
              }}
            >
              <Box
                component="img"
                src={connection}
                sx={{ borderRadius: 400, width: 70 }}
              />
              <Typography
                sx={{ mt: 2.4, ml: 0, fontSize: "1.1rem", color: "#022a6b" }}
              >
                Customer Connection
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <OfferCard />
      <Trending />
      <Summercollection />
      <Wintercollection />
      <Comments />
    </React.Fragment>
  );
};

export default Homepage;
